import React from 'react'
import SubGradeInput from './subgradeinput'

export default function SubGrade({lessonname , lesson1, setLesson1, lesson2, setLesson2, grade1, setGrade1, grade2, setGrade2}) {
   // console.log("lessonname",lessonname);
    let inputname1 = lessonname + "lesson1";
    let inputname2 = lessonname + "lesson2";
  return (
    <div className="col">
    <SubGradeInput inputname = {inputname1} lesson={lesson1} setLesson={setLesson1} grade={grade1} setGrade={setGrade1}/>
    <SubGradeInput inputname = {inputname2} lesson={lesson2} setLesson={setLesson2} grade={grade2} setGrade={setGrade2}/>
  </div>
  )
}
